<span *ngIf="priceDifference !== '0.00'">
  <i
    [ngClass]="
      sign === '+' ? 'bi bi-caret-up-fill price-increase' : 'bi bi-caret-down-fill price-decrease'
    "
  ></i>
  <span [ngStyle]="{ color: sign === '+' ? 'red' : 'green' }"> ${{ priceDifference }} </span>
</span>
